<!-- src/components/PdfViewer/index.vue -->
<template>
  <div class="pdf-container" v-loading="loading">
    <!-- 分页控制 -->
    <div class="page-tool">
      <div>
        <el-button @click="prevPage" :disabled="pageNum <= 1">上一页</el-button>
        <span>{{ pageNum }} / {{ totalPage }}</span>
        <el-button @click="nextPage" :disabled="pageNum >= totalPage">下一页</el-button>
      </div>
      <el-button size="mini" @click="handleAudit" type="danger">{{ auditText }}</el-button>
    </div>
    <!-- 新增固定高度滚动容器，绑定ref -->
    <div class="pdf-scroll-box" ref="scrollBox">
      <canvas ref="pdfCanvas"></canvas>
    </div>
  </div>
</template>

<script>
  // 正确完整导入
  import * as pdfjsLib from "pdfjs-dist/build/pdf";
  import pdfWorker from "pdfjs-dist/build/pdf.worker.entry";
  // 绑定worker
  pdfjsLib.GlobalWorkerOptions.workerSrc = pdfWorker;

  export default {
    name: "PdfViewer",
    props: {
      // 外部传入pdf地址
      pdfUrl: {
        type: String,
        default: ""
      },
      // 缩放比例
      scale: {
        type: Number,
        default: 1.1
      },
      // 审核按钮文字，外部可传
      auditText: {
        type: String,
        default: "返回列表"
      }
    },
    data() {
      return {
        loading: false,
        pdfDoc: null, // pdf文档实例
        pageNum: 1, // 当前页码
        totalPage: 0 // 总页数
      };
    },
    watch: {
      // 地址变化重新渲染
      pdfUrl: {
        handler(val) {
          if (val) this.loadPdf(val);
        },
        immediate: true
      }
    },
    methods: {
      // 点击审核，向外派发事件
      handleAudit() {
        this.$emit("audit");
      },
      async loadPdf(url) {
        if (!url) {
          this.$message.warning("PDF文件地址为空");
          return;
        }
        this.loading = true;
        this.pageNum = 1;
        try {
          // 原生getDocument替代报错的createLoadingTask
          const task = pdfjsLib.getDocument({
            url
          });
          this.pdfDoc = await task.promise;
          this.totalPage = this.pdfDoc.numPages;
          // 渲染第一页
          await this.renderPage(this.pageNum);
        } catch (err) {
          console.error("PDF加载失败", err);
          this.$message.error("文件加载失败，请检查链接");
        } finally {
          this.loading = false;
        }
      },
      // 渲染指定页码，保留签章渲染逻辑
      async renderPage(num) {
        const page = await this.pdfDoc.getPage(num);
        const viewport = page.getViewport({
          scale: this.scale
        });
        const canvas = this.$refs.pdfCanvas;
        const ctx = canvas.getContext("2d");
        canvas.width = viewport.width;
        canvas.height = viewport.height;
        const renderTask = page.render({
          canvasContext: ctx,
          viewport,
          includeAnnotationStorage: true
        });
        await renderTask.promise;
      },
      // 上一页
      async prevPage() {
        if (this.pageNum <= 1) return;
        this.pageNum--;
        await this.renderPage(this.pageNum);
        // 翻页滚动回顶部
        this.$refs.scrollBox.scrollTop = 0;
      },
      // 下一页
      async nextPage() {
        if (this.pageNum >= this.totalPage) return;
        this.pageNum++;
        await this.renderPage(this.pageNum);
        // 翻页滚动回顶部
        this.$refs.scrollBox.scrollTop = 0;
      }
    }
  };
</script>

<style scoped>
  .pdf-container {
    width: 100%;
    text-align: center;
  }

  .page-tool {
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  /* 固定高度滚动容器，超出滚动 + 隐藏滚动条 */
  .pdf-scroll-box {
    width: 100%;
    height: 560px;
    overflow: auto;
    border: 1px solid #eee;
    padding: 10px;
    box-sizing: border-box;

    /* 隐藏滚动条 兼容webkit(Chrome/Edge) */
    ::-webkit-scrollbar {
      display: none;
    }

    /* 兼容火狐 */
    scrollbar-width: none;
    /* IE兼容 */
    -ms-overflow-style: none;
  }

  canvas {
    border: 1px solid #eee;
    display: inline-block;
  }
</style>
